export const css = {
    root: '_27mAsYx4',
    title: '_23EpfNTa',
    cardRoot: '_2qWej1YE',
    icon: '_3GAPuduI',
    label: 'mOtqMa_I',
    faComplete: '_2i3kIVrX',
    progress: '_2XYZWB4S',
    actions: '_3x2oRfgf',
    reading: '_3Pk1s9d9',
    quiz: 'BhkCCrst',
    action: '_1oR7DLyp',
    ' _key': 'dashboard-widgets/cards'
};
export default css;
